import { Tag } from "antd";

function DeletedActivityTag() {
  return (
    <Tag className="border border-solid border-ciq-gray-300 rounded text-ciq-red-700 font-semibold bg-white">
      Deleted
    </Tag>
  );
}

export default DeletedActivityTag;
